import React from 'react';

export const MergeProspectContext = React.createContext<{
  mergeProspectUuid: string;
}>(null);
